/* eslint-disable */
import React from 'react';
import './index.less';
import './index.en.less';

export interface IDoDontColumn {
  title?: any;
  image?: string;
  items?: string[];
}

export interface IDoDontCardsProps {
  doColumn?: IDoDontColumn;
  dontColumn?: IDoDontColumn;
  id?: string;
  className?: string;
}

const renderColumn = (
  column: IDoDontColumn | undefined,
  variant: 'do' | 'dont'
) => {
  if (!column) return null;
  const { title, image, items = [] } = column;

  // @ts-ignore
  return (
    <div className={`do-dont-card do-dont-card--${variant}`}>
      {image && (
        <div className="do-dont-card-figure">
          <img src={image} alt="" />
          <div className="do-dont-card-title">
            <span
              className="do-dont-card-title-text"
              dangerouslySetInnerHTML={{ __html: title }}
            ></span>
          </div>
        </div>
      )}
      <ul className="do-dont-card-list">
        {items.map((item, index) => (
          <li key={index} className="do-dont-card-item">
            <span className="do-dont-card-item-text">{item}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

const DoDontCards: React.FunctionComponent<IDoDontCardsProps> = ({
  doColumn,
  dontColumn,
  id,
  className,
}) => {
  if (!doColumn && !dontColumn) return null;

  return (
    <div className={`do-dont-cards${className ? ` ${className}` : ''}`} id={id}>
      {renderColumn(doColumn, 'do')}
      {renderColumn(dontColumn, 'dont')}
    </div>
  );
};

export default React.memo(DoDontCards);
